import {OrderEngineContext, useAssets, useClient} from '@adamlip/okeoke.client';
import {Image} from '@heroui/react';
import {AppParamsContext} from 'contexts/AppParamsContext';
import {useContext, useEffect, useState} from 'react';
import {cn} from 'utils/utils';

function RenderBarSoftImage({uuid, wrapperClassName, imgClassName, ignoreDefaultClasses = false}) {
	const {appParams} = useContext(AppParamsContext);
	const {brandID} = useClient();

	const {assets} = useAssets();
	const {loadImage, getCachedAsset} = useContext(OrderEngineContext);

	const [src, setSrc] = useState(null);
	const [checked, setChecked] = useState(false);
	const defaultSrc = appParams?.assets?.defaultItemImg || '';
	const [defaultImageSrc, setDefaultImageSrc] = useState(null);
	useEffect(() => {
		if (uuid) {
			const item = assets[uuid.toUpperCase()];
			if (item) {
				const extension = item['extension'];
				const url = `https://${item.store}.okeoke.io/brands/${brandID}/assets/${item?.uuid.toLowerCase()}_l.${extension}`;
				// console.log(getCachedAsset(item?.uuid.toLowerCase()));
				loadImage(
					url,
					item?.uuid.toLowerCase(),
					true,
					() => {
						setSrc(url);
					},
					() => {
						setSrc(defaultSrc);
					}
				);
			} else {
			}
		} else {
			// setSrc(defaultSrc);
			setTimeout(() => {
				setDefaultImageSrc(defaultSrc);
			}, 1000);
			// setChecked(true);
		}
	}, [uuid, assets]);
	return (
		<Image
			src={src || defaultImageSrc}
			isBlurred={!checked}
			onLoad={() => {
				setChecked(true);
			}}
			isLoading={!checked}
			classNames={{
				wrapper: ignoreDefaultClasses ? wrapperClassName : cn('w-full h-full overflow-hidden !max-w-full bg-background', wrapperClassName),
				img: ignoreDefaultClasses ? imgClassName : cn('w-full h-full object-cover z-auto', imgClassName),
			}}
		/>
	);
}

export default RenderBarSoftImage;
